<template>
  <div id="sealList" v-show="show">
    <div @mousewheel.prevent @click.self="closeList" class="seal-modal"></div>
    <div class="sealDialog">
      <div class="top">
        <span class="title">选择印章</span>
        <span @click="closeList" class="closeIcon">x</span>
      </div>
      <div class="body" v-if="flash">
        <div class="eseal-content">
          <div class="leftBody">
            <div v-for="(item, index) in tabList" :key="index * 322 + 5555" class="tab" :class="item.isChoosed ? 'isChoosed' : ''"
              :style="item.type ? { color: '#333333' } : { cursor: 'pointer' }" @click="clickTab(item, index)">
              <div v-if="item.type" class="img" :class="item.index === -1 ? 'bg1' : 'bg2'"></div>
              <span :style="item.type ? { fontWeight: 'bold' } : ''">
                {{ item.title }}
              </span>
            </div>

            <div v-for="(item, index) in companyNameList" :key="index * 9999 + 233" class="tab" :class="item.isChoosed ? 'isChoosed' : ''"
              :style="item.type ? { color: '#333333' } : { cursor: 'pointer' }" @click="clickTabOfcomp(item, index)">
              <div v-if="item.type" class="img"></div>
              <span :style="item.type ? { fontWeight: 'bold' } : ''">
                {{ item.departmentName }}
              </span>
            </div>
          </div>
          <div class="rightBody" ref="rightBody">
            <!-- 个人章 -->
            <div v-show="tabIndex === 0&&item.downloadUrl" v-for="(item, index) in personalSealList" :key="index * 124 + 3213" class="sealItem"
              :style="personalSealList.length <= 8 ? { width: '145px' } : ''" :class="item.isChoosed ? 'isChoosed' : ''">
              <img :src="item.downloadUrl" @click="choosePersonSeal(item, index)" alt="" class="sealImg" />
              <div class="sealName">{{ item.sealName }}</div>
            </div>
            <!-- 公司印章列表  -->
            <div v-show="tabIndex == 10&&item.downloadUrl" v-for="(item, index) in sealList" :key="index * 132" class="sealItem" :style="sealList.length <= 8 ? { width: '145px' } : ''"
              :class="item.isChoosed ? 'isChoosed' : ''">
              <img :src="item.downloadUrl" @click="chooseComSeal(item, index)" alt="" class="sealImg" />
              <div class="sealName">{{ item.name }}</div>
            </div>
            <!-- 手绘印章 -->
            <div v-show="tabIndex === 1" class="handSealBody">
              <p class="title">请打开手机扫一扫，绘制手绘印章</p>
              <div id="qrcode" ref="qrCodeUrl"></div>
              <p>
                若二维码失效或异常，请
                <span @click="creatQrCode" style="color: #0975e0; cursor: pointer;">
                  刷新
                </span>
              </p>
              <div v-if="handWrite !== ''" class="handSealModal">
                <div class="modalBg"></div>
                <div class="modalContent">
                  <div class="img"></div>
                  <p>绘制成功</p>
                  <p>请点击确定完成手绘</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="buttonRoom">
          <button @click="closeList" class="cancel">取消</button>
          <button @click="confirm" :disabled="!choosedSeal" class="confirm">确定</button>
        </div>
      </div>
      <!-- 提醒框 -->
      <transition name="toast">
        <div v-if="toastShow" class="confirmToast">
          请先选择印章
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: "sealList",
    data: function() {
      return {
        tabList: [{
            title: "个人印章",
            type: 1,
            index: -1,
            isChoosed: false,
          },
          {
            title: "个人印章",
            type: 0,
            index: 0,
            isChoosed: true
          },
          {
            title: "企业印章",
            type: 1,
            index: -2,
            isChoosed: false,
          },
        ],
        tabIndex: 0,
        personalSealList: [],
        comSealList: [],
        companyNameList: [],
        sealList: [], // 筛选后在页面显示的公司章
        choosedSeal: "",
        toastShow: false,
        getKeyInterval: null,
        qrcode: "",
        uuid: "",
        handWrite: "",
        flash: true,
        timeDifference: "",
        currentComp: '',
        pageIndex: 1,
        show: false,
        loading: false,
        userInfo: {
          id: ''
        },
        serverUrl: ''
      }
    },
    watch: {
      show: function(now, old) {
        if (now) {
          this.$nextTick(function(params) {
            this.$refs.rightBody.addEventListener("scroll", this.handleScroll)
          })
        } else {
          this.$refs.rightBody.removeEventListener("scroll", this.handleScroll)
        }
      },
    },
    methods: {
      handleScroll: function(params) {
        if (
          this.$refs.rightBody.scrollTop + this.$refs.rightBody.clientHeight ===
          this.$refs.rightBody.scrollHeight && !this.loading
        ) {
          if (this.tabIndex == 0) {
            if (this.$refs.rightBody.scrollTop == 0) {
              return
            }
            this.reFindPersonalSealList()
          }
          if (this.tabIndex == 10) {
            if (this.$refs.rightBody.scrollTop == 0) {
              return
            }
            this.getComSealById()
          }
        }
      },
      creatQrCode: function() {
        var that = this
        this.handWrite = ""
        this.$refs.qrCodeUrl.innerHTML = ""
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          // text: handler.url + "?" + this.getuuid(), // 需要转换为二维码的内容
          text: handler.url + "?" + this.getuuid() + "&" + Date.parse(new Date()) + `&severUrl=${handler.severUrl}` + `&id=${handler.userInfo.id}`,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: 3 || QRCode.CorrectLevel.H,
        })
        this.getKeyInterval = setInterval(function() {
          if (that.handWrite) {
            clearInterval(that.getKeyInterval)
            return
          }
          that.getFileKey()
        }, 1000)
      },
      getuuid: function() {
        var s = []
        var hexDigits = "0123456789abcdef"
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = "4" // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-"

        var uuid = s.join("")
        this.uuid = uuid
        return uuid
      },
      // 关闭弹窗
      closeList: function() {
        for (var i in this.tabList) {
          this.tabList[i].isChoosed = false
        }
        this.tabList[1].isChoosed = true
        for (var i in this.sealList) {
          this.sealList[i].isChoosed = false
        }
        for (var i in this.personalSealList) {
          this.personalSealList[i].isChoosed = false
        }
        for (var i in this.companyNameList) {
          this.companyNameList[i].isChoosed = false;
        }
        this.qrcode = ""
        this.uuid = ""
        this.choosedSeal = ""
        this.tabIndex = 0
        this.handWrite = ""
        if (this.getKeyInterval !== null) {
          clearInterval(this.getKeyInterval)
        }
        this.currentComp = ''
        this.show = false
      },

      // 点击左侧tab栏  个人签章
      clickTab: function(item, index) {
        if (this.getKeyInterval !== null) {
          clearInterval(this.getKeyInterval)
        }
        if (item.type || this.tabIndex == item.index) return
        this.tabIndex = item.index
        this.choosedSeal = ""
        this.pageIndex = 1
        this.sealList = []
        this.personalSealList = []
        this.reFindPersonalSealList()
        for (var i in this.tabList) {
          this.tabList[i].isChoosed = false
        }
        for (var i in this.companyNameList) {
          this.companyNameList[i].isChoosed = false
        }
        this.currentComp = ''
        for (var i in this.sealList) {
          this.sealList[i].isChoosed = false
        }
        this.tabList[index].isChoosed = true
        // TODO
        if (this.tabIndex === 1) {
          this.creatQrCode()
          // this.regetTimestamp()
          // this.refreshCode();
        }
      },
      // 点击公司签章左侧栏
      clickTabOfcomp: function(item, index) {
        if (item === this.currentComp) {
          return
        }
        this.pageIndex = 1
        this.tabIndex = 10
        if (this.getKeyInterval !== null) {
          clearInterval(this.getKeyInterval)
        }
        for (var i in this.companyNameList) {
          this.companyNameList[i].isChoosed = false
        }
        for (var i in this.tabList) {
          this.tabList[i].isChoosed = false
        }
        for (var i in this.personalSealList) {
          this.personalSealList[i].isChoosed = false
        }
        this.companyNameList[index].isChoosed = true
        this.sealList = []
        // this.findSameNameSeal(item)
        this.currentComp = item
        this.getComSealById()
      },
      // 获取手绘结果
      getFileKey: function() {
        var that = this
        $.ajax({
          url: this.severUrl + "/V1/sealHandPainted/queryBySealUUID",
          type: "post",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST,GET",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            sealUUID: that.uuid,
          },
          success: function(data) {
            if (data.data.id) {
              that.handWrite = data.data.sealBase64
              that.choosedSeal = {
                sealBase64: data.data.sealBase64,
                sealUUID: data.data.sealUUID,
                ishand: true,
              }
            }
          },
          error: function(data) {
            console.log(that)
          },
        })
      },
      // 获取公司列表
      getCompList: function() {
        var that = this
        $.ajax({
          url: this.serverUrl + "/esignpro/rest/seal/getAccountIdSealManage",
          type: "post",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST,GET",
            "x-timevale-project-id": "1000000",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
          },
          data: {
            accountId: that.userInfo && that.userInfo.id,
          },
          success: function(data) {
            that.companyNameList = data.data.sealManageBeans
          },
          error: function(data) {
            console.log(that)
          },
        })
      },
      // 选择个人印章
      choosePersonSeal: function(item, index) {
        for (var i in this.personalSealList) {
          this.personalSealList[i].isChoosed = false
        }
        this.personalSealList[index].isChoosed = true
        this.choosedSeal = JSON.parse(JSON.stringify(item))
        this.choosedSeal.url = this.choosedSeal.downloadUrl
        this.flash = false
        this.$nextTick(function() {
          this.flash = true
        })
      },
      // 选择公司章
      chooseComSeal: function(item, index) {
        for (var i in this.sealList) {
          this.sealList[i].isChoosed = false
        }
        this.sealList[index].isChoosed = true
        this.choosedSeal = JSON.parse(JSON.stringify(item))
        this.choosedSeal.url = this.choosedSeal.downloadUrl
        this.flash = false
        this.$nextTick(function() {
          this.flash = true
        })
      },
      // 确定添加印章
      confirm: function() {
        this.$emit("choose-seal", this.choosedSeal, this.currentComp)
        this.closeList()
      },
      //查找个人印章
      reFindPersonalSealList: function() {
        var that = this
        $.ajax({
          url: this.serverUrl + "/V1/seals/innerPersonalSeals/list",
          type: "get",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST,GET",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
            "x-timevale-project-id": "1000000",
          },
          data: {
            accountId: that.userInfo && that.userInfo.id,
            pageIndex: that.pageIndex,
            pageSize: 10,
          },

          success: function(data) {
            if (data.errCode == 0) {
              that.pageIndex++
              that.loading = false
              for (var i in data.data.seals) {
                data.data.seals[i].isChoosed = false
                that.personalSealList.push(data.data.seals[i])
              }
            }
          },
          error: function(data) {
            console.log("error")
          },
        })
      },

      getComSealById: function() {
        var that = this
        this.loading = true
        $.ajax({
          url: this.serverUrl + "/V1/seals/innerOrgansSeals/list",
          type: "get",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST,GET",
            "x-timevale-signature": "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
            "x-timevale-project-id": "1000000",
          },
          data: {
            organizeId: that.currentComp.departmentId,
            accountId: that.userInfo && that.userInfo.id,
            pageIndex: that.pageIndex,
            pageSize: 10,
          },
          success: function(data) {
            if (data.errCode == 0) {
              that.loading = false
              that.pageIndex++
              for (var i in data.data.seals) {
                data.data.seals[i].departmentId = that.currentComp.departmentId
                that.sealList.push(data.data.seals[i])
              }
            }
          },
          error: function(data) {
            console.log("error")
          },
        })
      },
    },
    created() {
      console.log(this.a)
    }
  }
</script>

<style scoped>
  .seal-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000000;
    opacity: 0.5;
    z-index: 1001;
  }

  .sealDialog {
    position: fixed;
    top: calc(50% - 264px);
    left: calc(50% - 460px);
    width: 920px;
    height: 528px;
    background-color: #fff;
    z-index: 1001;
  }

  .sealDialog .top {
    position: relative;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #e8e8e8;
  }

  .sealDialog .top span {
    position: absolute;
    line-height: 50px;
  }

  .sealDialog .top .title {
    left: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  .sealDialog .top .closeIcon {
    right: 24px;
    font-size: 18px;
    color: #bfbfbf;
    cursor: pointer;
  }

  .sealDialog .body {
    width: 100%;
  }

  .sealDialog .body .eseal-content {
    width: calc(100% - 48px);
    height: 365px;
    margin: 24px;
    border: 1px solid #e8e8e8;
    background-color: #f7f8fa;
  }

  .sealDialog .body .eseal-content .leftBody {
    display: inline-block;
    width: 240px;
    height: 100%;
    overflow-y: auto;
    border-right: 1px solid #e8e8e8;
    background-color: #fff;
  }

  .sealDialog .body .eseal-content .leftBody .tab {
    position: relative;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 12px;
    color: #666666;
  }

  .sealDialog .body .eseal-content .leftBody .tab .img {
    position: absolute;
    width: 18px;
    height: 20px;
    left: 7px;
    top: 10px;
  }

  /* .sealDialog .body .eseal-content .leftBody .tab .bg1 {
  background: url("./icon/tabIcon0.png") no-repeat center center;
  background-size: 100% 100%;
    height:20px\9!important;
} */
  /* .sealDialog .body .eseal-content .leftBody .tab .bg2 {
  background: url("./icon/tabIcon1.png") no-repeat center center;
  background-size: 100% 100%;
} */
  .sealDialog .body .eseal-content .leftBody .tab span {
    line-height: 40px;
    margin-left: 30px;
    display: inline-block;
    width: calc(100% - 30px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .sealDialog .body .eseal-content .leftBody .isChoosed {
    background-color: #f7f8fa;
  }

  .sealDialog .body .eseal-content .leftBody .isChoosed:before {
    position: absolute;
    display: block;
    content: "";
    left: 0;
    width: 4px;
    height: 100%;
    background-color: #307bf6;
  }

  .sealDialog .body .eseal-content .rightBody {
    display: inline-block;
    width: calc(100% - 250px);
    height: 100%;
    overflow-y: auto;
  }

  /* 印章 */
  .sealDialog .body .eseal-content .rightBody .sealItem {
    position: relative;
    width: 143px;
    height: 180px;
    display: inline-block;
  }

  .sealDialog .body .eseal-content .rightBody .sealItem .sealImg {
    position: relative;
    display: block;
    width: 130px;
    height: 130px;
    margin: 15px auto 10px;
    background-color: #fff;
    cursor: pointer;
  }

  .sealDialog .body .eseal-content .rightBody .sealItem .sealImg:hover {
    border: 1px solid #307bf6;
  }

  .sealDialog .body .eseal-content .rightBody .sealItem .sealName {
    width: 100%;
    font-size: 12px;
    color: #666666;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .sealDialog .body .eseal-content .rightBody .isChoosed:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    top: 15px;
    right: 10px;
    border-width: 11px;
    border-style: solid;
    border-color: #307bf6 #307bf6 transparent transparent;
    background: none;
    color: #fff;
    font-size: 12px;
    z-index: 1;
  }

  .sealDialog .body .eseal-content .rightBody .isChoosed:after {
    content: "";
    position: absolute;
    width: 22px;
    height: 22px;
    top: 15px;
    right: 10px;
    background: url("./icon/icon0.png") no-repeat 9px 2px;
    background-size: 11px 10px;
    z-index: 1;
  }

  /* 手绘 */
  .sealDialog .body .eseal-content .rightBody .handSealBody {
    position: relative;
    width: 210px;
    margin: 0 auto;
    font-size: 14px;
    text-align: center;
    color: #333333;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .title {
    margin: 39px 0 23px;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .img {
    width: 195px;
    height: 195px;
    margin: 0 auto 28px;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .handSealModal {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 37px;
    left: 5px;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .handSealModal .modalBg {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: 0.5;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .handSealModal .modalContent {
    position: absolute;
    width: 110px;
    height: 100%;
    margin: 0 auto;
    top: 0;
    left: 45px;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .handSealModal .modalContent .img {
    width: 45px;
    height: 45px;
    margin: 55px auto 5px;
    background: url("./icon/successIcon.png") no-repeat center center;
    background-size: 100% 100%;
  }

  .sealDialog .body .eseal-content .rightBody .handSealBody .handSealModal .modalContent p {
    font-size: 12px;
    color: #fff;
    margin: 5px auto;
  }

  .sealDialog .bottom {
    position: relative;
    width: 100%;
    height: 65px;
    border-top: 1px solid #e8e8e8;
  }

  .sealDialog .bottom .buttonRoom {
    position: absolute;
    top: 16px;
    right: 0;
  }

  .sealDialog .bottom .buttonRoom button {
    border: none;
    margin-right: 15px;
    width: 72px;
    height: 32px;
    border-radius: 3px;
    font-size: 14px;
    outline: none;
    cursor: pointer;
  }

  .sealDialog .bottom .buttonRoom .cancel {
    background-color: #fff;
    color: #666666;
    border: 1px solid #d9d9d9;
  }

  .sealDialog .bottom .buttonRoom .confirm {
    background-color: #0975e0;
    color: #fff;
  }

  .confirmToast {
    position: absolute;
    width: 545px;
    height: 50px;
    background-color: #fef6e9;
    border: 1px solid #fcecd3;
    border-radius: 3px;
    top: -20px;
    left: 167.5px;
    color: #f0a225;
    font-size: 14px;
    line-height: 50px;
    padding-left: 38px;
  }

  .confirmToast:before {
    content: "";
    width: 12px;
    height: 12px;
    position: absolute;
    background: url("./icon/errowIcon.png") no-repeat center center;
    background-size: 100% 100%;
    left: 15px;
    top: 19px;
  }

  .toast-enter,
  .toast-leave-to {
    opacity: 0;
    top: -10px;
  }

  .toast-enter-to,
  .toast-leave {
    opacity: 1;
    top: -20px;
  }

  .toast-enter-active,
  .toast-leave-active {
    transition: all 0.6s;
  }

  #qrcode {
    margin-left: 6px;
    margin-top: -5px;
  }
</style>
